import React from 'react'
import apple from '../assets/apple.jpg'
import youtube from '../assets/youtube.png'
import spotify from '../assets/spotify.jpg'
import BestOfStorytimeLogo from '../assets/podcastLogos/storytimePodcast.jpg'
import SuzyAndFriendsLogo from '../assets/podcastLogos/suzyAndFriendsPodcast.jpg'
import NanogirlLogo from '../assets/podcastLogos/nanogirlPodcast.jpg'
import MrHugoLogo from '../assets/podcastLogos/mrHugoPodcast.jpg'

import callout from '../css/modules/callout.module.scss'

export default class CalloutContainer extends React.Component {
  constructor() {
    super()
  }

  render() {
    return (
      <div className={callout.calloutContainer}>
        {/* Suzy & Friends podcast Banner*/}
        <Callout
          title="Follow and listen to Suzy & Friends in a POD-cast"
          logo={SuzyAndFriendsLogo}
          bodyText="Join Suzy & Friends for a slice of a Kiwi kid’s life! Kids share their thoughts, talents, and tales; and hosts Suzy Cato and Trevor Plant share stories and silliness."
          rnzUrl="https://www.rnz.co.nz/podcast/suzy-and-friends"
          appleUrl="https://podcasts.apple.com/us/podcast/suzy-friends/id1729506823"
          spotifyUrl="https://open.spotify.com/show/04ef7DHbv7kG6MDAfLTq2G"
          youtubeUrl="https://www.youtube.com/playlist?list=PLB06qFjAt4VBnW7Xv2HrE-65Dlnzj17tv"
          bgColor="#FDF692"
        />
        {/* Mr Hugo's Little Library Banner*/}
        <Callout
          title="Follow and listen to Mr Hugo's Little Library"
          logo={MrHugoLogo}
          bodyText="Come in and play at Mr Hugo’s Little Library! Three young friends meet an enthusiastic librarian and discover a magic library where books come to life - literally!"
          rnzUrl="https://www.rnz.co.nz/podcast/mr-hugos-little-library"
          appleUrl="https://podcasts.apple.com/us/podcast/mr-hugos-little-library/id1896941633"
          spotifyUrl="https://open.spotify.com/show/033AKJzJ2tkws603BgSDQc"
          youtubeUrl="https://www.youtube.com/playlist?list=PLB06qFjAt4VCYyH1tuKQhkVEHTYgJ4w6c"
          bgColor="#D9BFED"
        />
        {/* Best of Storytime Banner*/}
        <Callout
          title="Follow and listen to the Best of Storytime"
          logo={BestOfStorytimeLogo}
          bodyText="Dive into a treasure trove of the greatest children's stories and songs from New Zealand. Ngā pūrākau me ngā waiata nā Aotearoa."
          rnzUrl="https://www.rnz.co.nz/programmes/best-of-storytime-rnz"
          appleUrl="https://itunes.apple.com/NZ/podcast/id1490511732"
          spotifyUrl="https://open.spotify.com/show/6F7ejhCoeNFeOVZvD5zreq?si=g8Xtx5HYTQ2OGyWA9ZYa-w"
          youtubeUrl="https://www.youtube.com/playlist?list=PLB06qFjAt4VDszhtYoTGfe_QJNDRwj5K4"
          bgColor="#D1ECF4"
        />
        {/* Nanogirl Banner*/}
        <Callout
          title="Follow and listen to Nanogirl's Great Science Adventures"
          logo={NanogirlLogo}
          bodyText="Answering your burning science questions and showing you the wonders of discovery."
          rnzUrl="https://www.rnz.co.nz/programmes/nanogirls-great-science-adventures"
          appleUrl="https://itunes.apple.com/nz/podcast/id1462120464"
          spotifyUrl="https://open.spotify.com/show/1RSLlXSmJeQ2I9LpvMYCa7"
          youtubeUrl="https://www.youtube.com/playlist?list=PLB06qFjAt4VALSZ9bf2wxqTrzGI2IOmFZ"
          bgColor="#FAEED0"
        />
      </div>
    )
  }
}

class Callout extends React.Component {
  constructor() {
    super()
  }

  render() {
    const bodyTextMobile = (
      <div className={callout.bodyText}>
        <p>{this.props.bodyText}</p>
        <a href={this.props.rnzUrl}>
          <span className={callout.underline}>Find out more</span> →
        </a>
      </div>
    )

    const bodyTextDesktop = (
      <div className={callout.bodyText}>
        <p>
          {this.props.bodyText}
          <a href={this.props.rnzUrl}>
            <span className={callout.underline}>Find out more</span> →
          </a>
        </p>
      </div>
    )

    const logos = (
      <div className={callout.podcastWrapper}>
        <a href={this.props.appleUrl}>
          <img
            alt="Subscribe to Apple Podcasts"
            className={callout.podcast}
            src={apple}
          />
        </a>
        <a href={this.props.spotifyUrl}>
          <img
            alt="Subscribe to Spotify"
            className={callout.podcast}
            src={spotify}
          />
        </a>
        <a href={this.props.youtubeUrl}>
          <img
            alt="Subscribe to Youtube"
            className={callout.podcast}
            src={youtube}
          />
        </a>
      </div>
    )

    return (
      <div
        className={callout.container}
        style={{ backgroundColor: `${this.props.bgColor}` }}>
        <div className={callout.wrapper}>
          <div className={callout.headerContainer}>
            <h2>{this.props.title}</h2>
            <div className={callout.desktopContent}>
              {bodyTextDesktop}
              {logos}
            </div>
          </div>
          <div className={callout.logoContainer}>
            <a href={this.props.rnzUrl}>
              <img
                alt="Best of Storytime podcast"
                className={callout.logo}
                src={this.props.logo}
              />
            </a>
            <div
              className={[callout.mobileContent, callout.mobileText].join(' ')}>
              {bodyTextMobile}
            </div>
            <div
              className={[callout.mobileContent, callout.mobileLogo].join(' ')}>
              {logos}
            </div>
          </div>
        </div>
      </div>
    )
  }
}
